module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Girl Who Dressed like a Boy")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-the-end-and-the-beginning"
    }
  }, [_vm._v("Chapter 1: The End and the Beginning")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-the-centre"
    }
  }, [_vm._v("Chapter 2: The Centre")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3-an-eastern-alliance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: An Eastern Alliance")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-return-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Return Journey")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-fate-plays-a-hand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Fate Plays a Hand")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-the-south-west",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The South West")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-visitors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Visitors")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-wolves-of-winter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Wolves of Winter")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-coming-of-spring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Coming of Spring")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-reversal-of-fortunes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Reversal of Fortunes")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-the-toy-of-kings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Toy of Kings")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-normality-resumed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Normality Resumed?")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-war-with-the-welsh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: War with the Welsh")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-the-summer-queen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Summer Queen")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-more-trouble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: More Trouble")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-harvest-home-the-wedding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Harvest Home – The Wedding")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0